(function () {
  function getModal() {
    return document.querySelector('.filter-modal');
  }
  function getTrigger() {
    return document.querySelector('.filter-trigger');
  }
  function isVisible(el) {
    if (!el) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity) > 0;
  }
  function showModal(modal, trigger) {
    if (!modal || !trigger) return;
    modal.style.display = 'block';
    modal.style.opacity = '0';
    modal.offsetHeight; // reflow
    modal.style.transition = 'opacity 0.15s ease';
    modal.style.opacity = '1';
    trigger.classList.remove('btn-primary', 'filter-overlay-button');
    trigger.classList.add('btn-default');
    document.body.classList.add('block-body-scroll');
  }
  function hideModal(modal, trigger) {
    if (!modal || !trigger) return;
    modal.style.transition = 'opacity 0.15s ease';
    modal.style.opacity = '0';
    setTimeout(function () {
      modal.style.display = 'none';
      modal.style.opacity = '';
    }, 150);
    trigger.classList.remove('btn-default');
    trigger.classList.add('btn-primary', 'filter-overlay-button');
    document.body.classList.remove('block-body-scroll');
  }
  function toggleModal() {
    var modal = getModal();
    var trigger = getTrigger();
    if (!modal || !trigger) return;
    if (isVisible(modal)) {
      hideModal(modal, trigger);
    } else {
      showModal(modal, trigger);
    }
  }
  function closeModal() {
    var modal = getModal();
    var trigger = getTrigger();
    if (!modal || !trigger) return;
    hideModal(modal, trigger);
  }
  document.addEventListener('click', function (e) {
    var target = e.target.closest ? e.target.closest('.filter-trigger') : (e.target.classList && e.target.classList.contains('filter-trigger') ? e.target : null);
    if (target) {
      e.preventDefault();
      toggleModal();
      return;
    }
    if (e.target.closest && e.target.closest('.modal-close')) {
      e.preventDefault();
      closeModal();
    }
  });
})();
